import api from "./api";

const users = {}
/*
Функция отправляет данные для входа на сервер и возвращает Promise с ответом с севера
*/
users.login = function(credentials){
  return api.post('/api/users/login', credentials)
}
/*
  Функция отправляет на сервер запрос на выход и возвращает Promise с результатом: ok - успешное завершение
*/
users.logout = function(){
  return api.post('/api/users/logout')
}
/*
  Функция отправляет на сервер запрос на добавление нового пользователя
*/
users.save = function save(credentials){
  return api.post('/api/users/save', credentials)
}

export default users;